import React from 'react';
import { Card, CardBody, Button } from 'reactstrap';
import { Link } from 'react-router-dom';

const PatientControlCard = (props: {
  active?: boolean;
  archived?: boolean;
  onSetActive?: (active: boolean) => void;
  onFinalize?: () => void;
  reviewPath?: string;
}) => (
  <Card>
    <CardBody>
      <Button
        tag={Link}
        to={props.reviewPath}
        disabled={!props.reviewPath || props.archived || !props.active}
        className="mr-2"
        color="primary">
        My Choices
      </Button>
      <Button
        disabled={!props.onSetActive || !props.active}
        color="warning"
        onClick={() =>
          props.onSetActive ? props.onSetActive(!!props.archived) : undefined
        }>
        {props.archived ? 'Restore' : 'Archive'}
      </Button>
      <Button
        disabled={!props.onFinalize || !props.active}
        className="float-right"
        color="danger"
        onClick={props.onFinalize}>
        {props.archived ? 'Resume' : 'Suspend'}
      </Button>
    </CardBody>
  </Card>
);

export default PatientControlCard;
